import { gql } from '@apollo/client'

export const SEND_QUESTION = gql`
  mutation sendQuestion($question: String!, $email: String) {
    sendQuestion(question: $question, email: $email)
  }
`
